import type { ReactNode } from "react";

/** Les glyphes du menu d'informations : traits fins, `currentColor`, jamais lus par un lecteur d'écran. */
function Icone({ taille = 20, children, plein = false }: { taille?: number; children: ReactNode; plein?: boolean }) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 24 24"
      fill={plein ? "currentColor" : "none"}
      stroke={plein ? "none" : "currentColor"}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      style={{ flex: "none" }}
    >
      {children}
    </svg>
  );
}

type P = { taille?: number };

/** ⓘ */
export const IconeInfo = ({ taille }: P) => (
  <Icone taille={taille}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.5" />
    <circle cx="12" cy="7.8" r=".6" fill="currentColor" />
  </Icone>
);

/** ⋯ */
export const IconePlus = ({ taille }: P) => (
  <Icone taille={taille} plein>
    <circle cx="5.5" cy="12" r="1.7" />
    <circle cx="12" cy="12" r="1.7" />
    <circle cx="18.5" cy="12" r="1.7" />
  </Icone>
);

export const IconeCredits = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M5 4.5h14v15H5z" />
    <path d="M8.5 9h7M8.5 12.5h7M8.5 16h4" />
  </Icone>
);

export const IconeCommandes = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11m0-1.5a1.5 1.5 0 0 1 3 0V11m0-.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.5a5 5 0 0 1-4-2L4.5 15.5a1.4 1.4 0 0 1 2.2-1.7L9 16" />
  </Icone>
);

export const IconePleinEcran = ({ taille, sortie = false }: P & { sortie?: boolean }) => (
  <Icone taille={taille}>
    {sortie ? <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" /> : <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />}
  </Icone>
);

/** ↗ : le lien s'ouvre dans un nouvel onglet. */
export const IconeExterne = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M8 16 16.5 7.5M9 7.5h7.5V15" />
  </Icone>
);

export const IconeChevronDroite = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M9 5l7 7-7 7" />
  </Icone>
);

export const IconeChevronGauche = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M15 5l-7 7 7 7" />
  </Icone>
);

export const IconeFermer = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Icone>
);

export const IconeAccueil = ({ taille }: P) => (
  <Icone taille={taille}>
    <path d="M4 11.5 12 5l8 6.5" />
    <path d="M6 10.5V19h12v-8.5M10 19v-5h4v5" />
  </Icone>
);
